// extracted by mini-css-extract-plugin
module.exports = {"play_pause":"PlayPause_play_pause__HTVXR"};